<script>
  import { getContext, onMount, createEventDispatcher, onDestroy } from 'svelte';
  const { data, xGet, yGet, xScale, yScale, padding } = getContext('LayerCake');
  export let control_action;
  let gate = null;
  let zoom_rect = null;
  let draw = false;
  let g;

  let dispatch = createEventDispatcher();

  function oMousePosSVG(e) {
    let svg = g.closest("svg");
    var p = svg.createSVGPoint();
    p.x = e.clientX;
    p.y = e.clientY;
    var ctm = svg.getScreenCTM().inverse();
    var p =  p.matrixTransform(ctm);
    p.x = p.x-$padding.left;
    p.y = p.y-$padding.top;
    return p;
  }

  function start_draw(e){
	  var p = oMousePosSVG(e);
	  gate = {
	    min_x: $xScale.invert(p.x),
	    min_y: $yScale.invert(p.y),
	    max_x: $xScale.invert(p.x),
	    max_y: $yScale.invert(p.y),
	  }
	  draw = true;

  }

  function drag(e){
    if(draw){
      var p = oMousePosSVG(e);
      var x = Math.min(gate.min_x, $xScale.invert(p.x));
      var y = Math.min(gate.min_y, $yScale.invert(p.y));
      var max_x = Math.max(gate.max_x, $xScale.invert(p.x));
      var max_y = Math.max(gate.max_y, $yScale.invert(p.y));
      gate = {
        min_x: x,
        min_y: y,
        max_x: max_x,
        max_y: max_y
      }
    }
  }

  function end_draw(e){
    if(draw){
      draw = false;
      if(gate && gate.min_x == gate.max_x && gate.min_y == gate.max_y){
      	dispatch("zoom-end", {});
        gate = null;
      }
      else{
      	dispatch("zoom-end", {xDomain: [gate.min_x, gate.max_x], yDomain: [gate.min_y, gate.max_y]});
      	gate = null;
      }
      control_action = null;
      // dispatch("selection", gate)
      
    }
  }


  onMount(()=>{
    let svg = g.closest("svg");
    svg.addEventListener("mousedown", start_draw);
    svg.addEventListener("mousemove", drag);
    svg.addEventListener("mouseup", end_draw);
  })

  $:{
    if(gate){
      zoom_rect = {
        x: $xScale(gate.min_x),
        y: $yScale(gate.max_y),
        width: $xScale(gate.max_x) - $xScale(gate.min_x),
        height: $yScale(gate.min_y) - $yScale(gate.max_y),
      }
    }
    else{
      zoom_rect = null;
    }
  }

  onDestroy(()=>{
    let svg = g.closest("svg");
    svg.removeEventListener("mousedown", start_draw);
    svg.removeEventListener("mousemove", drag);
    svg.removeEventListener("mouseup", end_draw);
  })




</script>
<g bind:this={g}>
  {#if zoom_rect}
    <rect class="draw" x='{zoom_rect.x}' y='{zoom_rect.y}' width='{zoom_rect.width}' height='{zoom_rect.height}'></rect>
  {/if}
</g>

<style>

  rect{
    fill: transparent;
    stroke: black;
    stroke-width: 3;
    stroke-dasharray: 3,3;
  }

</style>
